// import Modal from "../../../../../components/Modal";
// import dateFormat from "../../../../../utils/dateFormat";

// export default function RecordsImportModal({
//   isModalOpen,
//   toggleModal,
//   importedData,
//   saveImportedData,
//   onDelete,
//   onEdit,
// }) {
//   console.log("Imported", importedData);
//   const handleImport = () => {
//     saveImportedData(importedData);
//     toggleModal();
//   };

//   const headers = [
//     "Case No.",
//     "First Name",
//     "Middle Name",
//     "Last Name",
//     "Alias",
//     "Company",
//     "Date Filed",
//     "Action",
//   ];
//   return (
//     <Modal isOpen={isModalOpen} size="xl">
//       <div className="w-100">
//         <div className="d-flex w-100 justify-content-between p-4">
//           <h5 className="fw-semibold text-primary">Confirm Imported Data</h5>
//         </div>
//         <div className="overflow-scroll mx-2">
//           <table class="table mt-3">
//             <thead>
//               <tr className="fs-sm">
//                 <th scope="col" className="fw-bold">
//                   #
//                 </th>
//                 {headers.map((header) => {
//                   return (
//                     <>
//                       <th scope="col" style={{ minWidth: "150px" }}>
//                         {header}
//                       </th>
//                     </>
//                   );
//                 })}
//                 {/* <th scope="col">Case No.</th>
//                 <th scope="col">First Name</th>
//                 <th scope="col">Middle Name</th>
//                 <th scope="col">Last Name</th>
//                 <th scope="col">Alias</th>
//                 <th scope="col" style={{ minWidth: "100px" }}>
//                   Date Filed
//                 </th>
//                 <th scope="col">Company</th>
//                 <th scope="col">Action</th> */}
//               </tr>
//             </thead>

//             <tbody>
//               {importedData && importedData.length > 0 ? (
//                 importedData.map((data, index) => {
//                   const {
//                     firstName,
//                     middleName,
//                     lastName,
//                     alias,
//                     branch,
//                     dateFiled,
//                     plaintiff,
//                     natureOfCase,
//                     caseType,
//                     courtType,
//                     court,
//                     company,
//                     caseNumber,
//                     caseNo,
//                   } = data;

//                   return (
//                     <tr key={index}>
//                       <td className="fs-sm fw-bold">{index + 1}</td>
//                       <td className="fs-sm">{caseNumber || caseNo}</td>
//                       <td className="fs-sm">{firstName}</td>
//                       <td className="fs-sm">{middleName}</td>
//                       <td className="fs-sm">{lastName}</td>
//                       <td className="fs-sm">{alias}</td>
//                       <td className="fs-sm">{company}</td>
//                       <td className="fs-sm">{dateFormat(dateFiled)}</td>
//                       <td className="fs-sm d-flex flex-nowrap">
//                         <button
//                           className="btn btn-primary me-2"
//                           style={{ backgroundColor: "" }}
//                           onClick={() => onEdit(index, data)}
//                         >
//                           Edit
//                         </button>
//                         <button
//                           className="btn btn-danger"
//                           onClick={() => onDelete(index)}
//                         >
//                           Delete
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td
//                     colSpan={headers.length + 1}
//                     className="text-center text-muted"
//                   >
//                     No data to display.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         <div className="d-flex justify-content-end gap-2 p-3">
//           <button
//             className="btn"
//             style={{ backgroundColor: "#fdb007" }}
//             onClick={onEdit}
//           >
//             Add
//           </button>
//           <button className="btn btn-light" onClick={toggleModal}>
//             Close
//           </button>
//           <button className="btn btn-primary" onClick={handleImport}>
//             Confirm and Save
//           </button>
//         </div>
//       </div>
//     </Modal>
//   );
// }

import Modal from "../../../../../components/Modal";
import dateFormat from "../../../../../utils/dateFormat";

export default function RecordsImportModal({
  isModalOpen,
  toggleModal,
  importedData,
  saveImportedData,
  onDelete,
  onEdit,
}) {
  console.log("Imported", importedData);
  const handleImport = () => {
    saveImportedData(importedData);
    toggleModal();
  };

  const headers = [
    "Case No.",
    "First Name",
    "Middle Name",
    "Last Name",
    "Alias",
    "Company",
    "Date Filed",
    "Action",
  ];
  return (
    <Modal isOpen={isModalOpen} size="xl">
      <div className="w-100">
        <div className="d-flex w-100 justify-content-between p-4">
          <h5 className="fw-semibold text-primary">Confirm Imported Data</h5>
        </div>
        <div
          className="mx-2"
          style={{
            maxHeight: "500px",
            overflowY: "auto",
            overflowX: "auto",
          }}
        >
          <table className="table mt-3">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 1,
              }}
            >
              <tr className="fs-sm">
                <th scope="col" className="fw-bold">
                  #
                </th>
                {headers.map((header, idx) => {
                  return (
                    <th key={idx} scope="col" style={{ minWidth: "150px" }}>
                      {header}
                    </th>
                  );
                })}
              </tr>
            </thead>

            <tbody>
              {importedData && importedData.length > 0 ? (
                importedData.map((data, index) => {
                  const {
                    firstName,
                    middleName,
                    lastName,
                    alias,
                    branch,
                    dateFiled,
                    plaintiff,
                    natureOfCase,
                    caseType,
                    courtType,
                    court,
                    company,
                    caseNumber,
                    caseNo,
                  } = data;

                  return (
                    <tr key={index}>
                      <td className="fs-sm fw-bold">{index + 1}</td>
                      <td className="fs-sm">{caseNumber || caseNo}</td>
                      <td className="fs-sm">{firstName}</td>
                      <td className="fs-sm">{middleName}</td>
                      <td className="fs-sm">{lastName}</td>
                      <td className="fs-sm">{alias}</td>
                      <td className="fs-sm">{company}</td>
                      <td className="fs-sm">{dateFormat(dateFiled)}</td>
                      <td className="fs-sm">
                        <div className="d-flex flex-nowrap gap-2">
                          <button
                            className="btn btn-primary"
                            onClick={() => onEdit(index, data)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => onDelete(index)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={headers.length + 1}
                    className="text-center text-muted"
                  >
                    No data to display.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-end gap-2 p-3">
          <button
            className="btn"
            style={{ backgroundColor: "#fdb007" }}
            onClick={onEdit}
          >
            Add
          </button>
          <button className="btn btn-light" onClick={toggleModal}>
            Close
          </button>
          <button className="btn btn-primary" onClick={handleImport}>
            Confirm and Save
          </button>
        </div>
      </div>
    </Modal>
  );
}
